import { StateAwareNavigate } from "@components/routes/StateAwareNavigate";
import React from "react";
import { useLocation } from "react-router-dom";

export const CashflowToInsightsRedirect: React.FC = () => {
    const location = useLocation();
    return (
        <StateAwareNavigate
            to={{
                ...location,
                pathname: "/insights",
            }}
            replace
        />
    );
};
